module.exports = __webpack_public_path__ + "static/media/ourClients logo .f7d8f6b8.svg";